import React, { Component } from 'react'
import ReactTable from 'react-table'
import {
  Button,
  Form,
  Modal,
  Popconfirm,
  Input,
  Table,
  AutoComplete,
  Icon,
  Radio,
  message,
  Spin,
  Tooltip,
  Upload
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import Loader from '../../common/Loader'
import { actions as rfiActions } from '../../../redux/modules/jobFunctions/jobSiteRFIActions'
import { actions as organizationsActions } from '../../../redux/modules/organizationsActions'
import {
  convertToOption,
  filterCaseInsensitive,
  arrayMove,
  getSelectedOrganization,
  getModalId
} from '../../../util'
import config from '../../../config'
import OrganizationQuickAdd from '../../../components/organization//OrganizationQuickAdd'
import history from '../../../history'

const { API_BASE } = config
const FormItem = Form.Item
const RadioButton = Radio.Button
const RadioGroup = Radio.Group
const { Column } = Table
const { TextArea } = Input
const propTypes = {}

const AddItemArea = styled.div`
  padding-top: 10px;
  margin-bottom: 10px;
  padding-right: 10px;
`

const FilesUploadContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  -webkit-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
`

const EditAttachmentContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`
const EditAttachmentTitle = styled.h6`
  color: #fff;
`
const EditingFileContainer = styled.div`
  margin: 10px 0;
`

const EditableCell = ({ editable, value, onChange }) => (
  <div>
    {editable ? (
      <Input style={{ margin: '-5px 0' }} value={value} onChange={e => onChange(e.target.value)} />
    ) : (
      value
    )}
  </div>
)

class JobSiteRFIs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: getModalId(props.location.pathname),
      contentData: null
    }

    this.props.jobSiteRFIsRefresh({
      jobId: this.props.jobId,
      next: (payload, err) => {
        const changeOrderId = getModalId(this.props.location.pathname)
        if (changeOrderId) {
          if (!err) {
            const results = _.get(payload, 'data')
            const current = _.find(results, { id: parseInt(changeOrderId, 10) })
            if (current) {
              this.handleRowClick(current)
            } else {
              message.warning('This Purchase Order was deleted or does not exist.')
            }
          }
        }
      }
    })
    this.props.getAllOrganizations()
  }

  componentDidUpdate(prevProps) {
    if (this.props.jobSiteRFIActions.rfiItems !== prevProps.jobSiteRFIActions.rfiItems) {
      this.setState({
        rfiItems: this.props.jobSiteRFIActions.rfiItems.data
      })
    }
  }

  handleRowClick = row => {
    this.setState({
      currentId: row.id,
      contentData: row
    })
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/site-rfi/modal/${row.id}`)
    this.props.getRfiData({
      jobId: this.props.jobId,
      rfiId: row.id
    })
  }

  handleAddButton = () => {
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/site-rfi/modal/0`)
    this.setState({
      currentId: 0,
      contentData: null,
      rfiItems: [],
      addQuestionInput: '',
      addResponseInput: ''
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/site-rfi`)
    this.setState({ data: [], currentId: 0 })
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      values.organization_id = getSelectedOrganization(
        this.props.organizationsActions.payload.data,
        values.organization_id
      )

      if (this.state.currentId === 0) {
        this.props.createRFI({
          jobId: this.props.jobId,
          content: values,
          rfiItems: this.state.rfiItems,
          userId: this.props.user.userId
        })
      } else {
        if (isNaN(values.organization_id)) {
          values.organization_id = this.props.organizationsActions.payload.data.filter(
            item => item.name === values.organization_id
          )[0].id
        }

        this.props.updateRFI({
          jobId: this.props.jobId,
          rfiId: this.state.currentId,
          content: values,
          rfiItems: this.state.rfiItems,
          userId: this.props.user.userId
        })
      }

      form.resetFields()
      message.success('Changes saved.')
      const { jobId, jobType } = this.props.match.params
      history.push(`/jobView/${jobId}/${jobType}/site-rfi`)
      this.setState({
        contentData: null,
        currentId: 0,
        rfiItems: [],
        addQuestionInput: '',
        addResponseInput: ''
      })
    })
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.deleteRFI({
      jobId: this.props.jobId,
      rfiId: this.state.currentId
    })

    form.resetFields()
    message.success('Record deleted.')
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/site-rfi`)
    this.setState({
      contentData: null,
      currentId: 0
    })
  }

  renderColumns(text, record, column) {
    return (
      <EditableCell
        editable={record.isEditingRow}
        value={text}
        onChange={value => this.handleItemsInputChange(value, record.id, column)}
      />
    )
  }

  handleAddInputChange = (value, input) => {
    this.setState({ [input]: value })
  }

  handleItemsInputChange = (value, key, column) => {
    const groupedItems = this.state.rfiItems.map(row => {
      if (row.id === key) row[column] = value
      return row
    })
    this.setState({
      rfiItems: groupedItems
    })
  }

  handleAddItemClick = () => {
    const items = this.state.rfiItems

    items.push({
      question: this.state.addQuestionInput,
      response: this.state.addResponseInput,
      id: items.length
    })
    this.setState({
      addQuestionInput: '',
      addResponseInput: '',
      rfiItems: items
    })
  }

  editRow = rowId => {
    const groupedItems = this.state.rfiItems.map(row => {
      if (row.id === rowId) row.isEditingRow = true
      return row
    })
    this.setState({
      rfiItems: groupedItems
    })
  }

  saveRow = rowId => {
    const groupedItems = this.state.rfiItems.map(row => {
      if (row.id === rowId) {
        row.isEditingRow = false
      }
      return row
    })
    this.setState({
      rfiItems: groupedItems
    })
  }

  deleteRow = rowId => {
    const groupedItems = this.state.rfiItems.filter(item => item.id !== rowId)

    this.setState({
      rfiItems: groupedItems
    })
  }

  uploadAttachment = uploadParam => {
    const formData = new FormData()

    formData.append('file', uploadParam.file)
    formData.append('type', 'job_minute')
    formData.append('filename', uploadParam.file.name)
    formData.append('description', uploadParam.file.name)
    formData.append('rfiId', this.state.currentId)

    this.props.uploadAttachment({
      formData: formData,
      rfiId: this.state.currentId
    })
  }

  handleAttachmentRowClick = row => {
    this.setState({
      attachmentDetailsVisible: true,
      attachmentId: row.id,
      attachmentName: row.filename,
      attachmentDescription: row.description
    })
  }

  onDescriptionChange = e => {
    this.setState({
      attachmentDescription: e.target.value
    })
  }

  handleUpdateAttachmentDescription = () => {
    this.props.updateAttachmentDescription({
      description: this.state.attachmentDescription,
      attachmentId: this.state.attachmentId,
      rfiId: this.state.currentId,
      userId: this.props.user.userId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  confirmAttachmentDelete = event => {
    this.props.deleteAttachment({
      attachmentId: this.state.attachmentId,
      rfiId: this.state.currentId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  moveUp = index => {
    const i = _.findIndex(this.state.rfiItems, { id: index })
    this.setState({
      requestItems: arrayMove(this.state.rfiItems, i, i - 1)
    })
  }

  moveDown = index => {
    const i = _.findIndex(this.state.rfiItems, { id: index })
    this.setState({
      requestItems: arrayMove(this.state.rfiItems, i, i + 1)
    })
  }

  /* Organization Quick Add */
  handleQuickAddOrganization = organization => {
    this.props.createNewOrganization({
      organization: organization,
      userId: this.props.user.userId
    })
    setTimeout(() => {
      this.props.getAllOrganizations()
    }, 1000)
  }

  handleBlurOrganization = organization => {
    if (organization !== '')
      this.setState({
        quickAddModalVisibility:
          _.findIndex(this.props.organizationsActions.payload.data, { id: +organization }) < 0 &&
          _.findIndex(this.props.organizationsActions.payload.data, { name: organization }) < 0
            ? true
            : false
      })
  }

  handleCancelQuickAdd = () => {
    this.setState({
      quickAddModalVisibility: !this.state.quickAddModalVisibility
    })
  }
  /* End Organization Quick Add */

  shouldRenderModal = () => {
    return /modal\/\d+$/.test(window.location.href)
  }

  render() {
    const { contentData } = this.state

    const uploadProps = {
      multiple: true,
      fileList: this.state.fileList
    }

    const { getFieldDecorator } = this.props.form
    if (!this.props.jobSiteRFIActions.jobSiteRFIs) {
      return <Loader />
    }
    return (
      <div>
        <OrganizationQuickAdd
          modalVisible={this.state.quickAddModalVisibility}
          handleCancel={this.handleCancelQuickAdd}
          handleQuickAddOrganization={this.handleQuickAddOrganization}
        />
        {this.shouldRenderModal() && (
          <Modal
            visible={true}
            title="RFI's"
            okText={contentData ? 'Save Changes' : 'Create'}
            onCancel={this.handleCancel}
            onOk={this.handleCreate}
            width={800}
            maskClosable={false}
          >
            {contentData && (
              <div className="row">
                <div className="col-md-9">
                  <FormItem label="Status">
                    {getFieldDecorator('status', {
                      initialValue: contentData ? contentData.status : ''
                    })(
                      <RadioGroup>
                        <RadioButton value="open">Open</RadioButton>
                        <RadioButton value="closed">Closed</RadioButton>
                      </RadioGroup>
                    )}
                  </FormItem>
                </div>
                <div className="col-md-3 text-right">
                  <a
                    href={`${API_BASE}/api/job/job_site_rfis/print/${contentData.id}`}
                    target="_blank"
                  >
                    <Button icon="printer" className="marginRight10">
                      Print as PDF
                    </Button>
                  </a>
                </div>
              </div>
            )}

            {contentData && (
              <div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="jobDetailsHeader">Created Date</div>
                    {`${moment(contentData.created_date).format('M/D/YYYY h:mm:ssa')}`}
                  </div>
                  <div className="col-md-4">
                    <div className="jobDetailsHeader">Updated Date</div>
                    {`${moment(contentData.updated_date).format('M/D/YYYY h:mm:ssa')}`}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="jobDetailsHeader">Created by</div>
                    {`${contentData.first_name} ${contentData.last_name}`}
                  </div>
                  <div className="col-md-4">
                    <div className="jobDetailsHeader">Updated by</div>
                    {`${contentData.updated_by_first_name} ${contentData.updated_by_last_name}`}
                  </div>
                </div>
              </div>
            )}

            <div className="row">
              <div className="col-md-6">
                <FormItem label="Company/Vendor Name">
                  {getFieldDecorator('organization_id', {
                    rules: [
                      {
                        required: true,
                        message: 'Company cannot be blank.'
                      }
                    ],
                    initialValue: contentData ? contentData.organization_name : ''
                  })(
                    <AutoComplete
                      dataSource={
                        this.props.organizationsActions &&
                        this.props.organizationsActions.payload &&
                        convertToOption(this.props.organizationsActions.payload.data)
                      }
                      filterOption={(inputValue, option) =>
                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                      }
                      style={{ width: 320 }}
                      placeholder="Search for a company/vendor"
                      onBlur={this.handleBlurOrganization}
                    >
                      <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                    </AutoComplete>
                  )}
                </FormItem>
              </div>
              <div className="col-md-6">
                <FormItem label="Attention">
                  {getFieldDecorator('attention', {
                    initialValue: contentData ? contentData.attention : ''
                  })(<Input placeholder="Attention to..." />)}
                </FormItem>
              </div>
            </div>
            <Form layout="vertical">
              <FormItem label="Description">
                {getFieldDecorator('description', {
                  rules: [
                    {
                      required: true,
                      message: 'Description cannot be blank.'
                    }
                  ],
                  initialValue: contentData ? contentData.description : ''
                })(<TextArea placeholder="Describe the RFI..." rows={4} />)}
              </FormItem>
              <Table
                dataSource={this.state.rfiItems}
                size="small"
                bordered
                pagination={false}
                rowKey="id"
              >
                <Column
                  title="Question"
                  dataIndex="question"
                  key="question"
                  width={250}
                  render={(text, record) => this.renderColumns(text, record, 'question')}
                />
                <Column
                  title="Response"
                  dataIndex="response"
                  key="response"
                  render={(text, record) => this.renderColumns(text, record, 'response')}
                />
                <Column
                  title=" "
                  dataIndex="action"
                  key="action"
                  render={(text, record) => {
                    return (
                      <div>
                        {record.isEditingRow && (
                          <Button
                            icon="save"
                            size="small"
                            onClick={() => this.saveRow(record.id)}
                          />
                        )}
                        {!record.isEditingRow && (
                          <Button
                            icon="edit"
                            size="small"
                            onClick={() => this.editRow(record.id)}
                          />
                        )}
                        <Button
                          icon="caret-up"
                          size="small"
                          onClick={() => this.moveUp(record.id)}
                        />
                        <Button
                          icon="caret-down"
                          size="small"
                          onClick={() => this.moveDown(record.id)}
                        />
                        <Popconfirm
                          title="Are you sure you want to delete this line?"
                          onConfirm={() => this.deleteRow(record.id)}
                          onCancel={this.cancelDelete}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button
                            size="small"
                            className="marginLeft5"
                            type="danger"
                            icon="delete"
                          />
                        </Popconfirm>
                      </div>
                    )
                  }}
                  width={150}
                />
              </Table>
              <AddItemArea>
                <div className="row">
                  <div className="col-md-5">
                    <Input
                      placeholder="Question"
                      value={this.state.addQuestionInput}
                      onChange={event =>
                        this.handleAddInputChange(event.target.value, 'addQuestionInput')
                      }
                    />
                  </div>
                  <div className="col-md-5">
                    <Input
                      placeholder="Response"
                      value={this.state.addResponseInput}
                      onChange={event =>
                        this.handleAddInputChange(event.target.value, 'addResponseInput')
                      }
                    />
                  </div>
                  <div className="col-md-2 text-right">
                    <Button onClick={() => this.handleAddItemClick()}>Add Item</Button>
                  </div>
                </div>
              </AddItemArea>
              {contentData && (
                <FilesUploadContainer>
                  <div className="row">
                    <div className="col-md-6">
                      <h6>
                        <Icon type="file" /> RFI Files
                      </h6>
                    </div>
                    <div className="col-md-6 text-right">
                      {this.props.jobSiteRFIActions &&
                        this.props.jobSiteRFIActions.uploadingAttachment && (
                          <div className="text-success">
                            <Icon type="loading" /> Uploading File(s)
                          </div>
                        )}
                      {this.props.jobSiteRFIActions &&
                        this.props.jobSiteRFIActions.deletingAttachment && (
                          <div className="text-danger">
                            <Icon type="loading" /> Deleting File(s)
                          </div>
                        )}
                    </div>
                  </div>
                  {this.props.jobSiteRFIActions.jobSiteRFIAttachments &&
                    this.props.jobSiteRFIActions.jobSiteRFIAttachments.data.length > 0 && (
                      <Spin spinning={this.props.jobSiteRFIActions.loadingAttachments}>
                        <ReactTable
                          defaultPageSize={5}
                          data={this.props.jobSiteRFIActions.jobSiteRFIAttachments.data}
                          getTrProps={(state, rowInfo, column, instance) => ({
                            onClick: e => this.handleAttachmentRowClick(rowInfo.original)
                          })}
                          defaultFilterMethod={filterCaseInsensitive}
                          columns={[
                            {
                              Header: 'Attached Files',
                              columns: [
                                {
                                  Header: 'Filename',
                                  id: 'filename',
                                  accessor: 'filename',
                                  Cell: d => (
                                    <Tooltip title={d.original.filename}>
                                      {d.original.filename}
                                    </Tooltip>
                                  )
                                },
                                {
                                  Header: 'Description',
                                  id: 'description',
                                  accessor: 'description',
                                  Cell: d => (
                                    <Tooltip title={d.original.description}>
                                      {d.original.description}
                                    </Tooltip>
                                  )
                                },
                                {
                                  Cell: row => (
                                    <Tooltip
                                      placement="left"
                                      title="Open this file on a new window"
                                    >
                                      <a target="_blank" href={row.original.signedUrl}>
                                        <Icon type="export" className="fontSize20" />
                                      </a>
                                    </Tooltip>
                                  ),
                                  maxWidth: 35
                                }
                              ]
                            }
                          ]}
                          defaultSorted={[
                            {
                              id: 'id',
                              desc: true
                            }
                          ]}
                          className="-striped -highlight"
                        />
                      </Spin>
                    )}
                  {this.state.attachmentDetailsVisible && (
                    <EditAttachmentContainer>
                      <EditAttachmentTitle>
                        <Icon type="edit" /> Edit Attachment Area
                      </EditAttachmentTitle>
                      <div>
                        <EditingFileContainer>
                          <Icon type="file" /> {this.state.attachmentName}
                        </EditingFileContainer>
                      </div>
                      <div className="row">
                        <div className="col-md-10">
                          <TextArea
                            placeholder="Describe the attachment..."
                            rows={4}
                            onChange={this.onDescriptionChange}
                            value={this.state.attachmentDescription}
                          />
                        </div>
                      </div>
                      <div className="d-flex flex-row mt-2">
                        <Button onClick={this.handleUpdateAttachmentDescription}>
                          <Icon type="save" /> OK
                        </Button>{' '}
                        <Popconfirm
                          title="Are you sure you want to delete this attachment?"
                          onConfirm={this.confirmAttachmentDelete}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button type="danger" icon="delete" className="ml-2">
                            {' '}
                            DELETE
                          </Button>
                        </Popconfirm>
                      </div>
                    </EditAttachmentContainer>
                  )}
                  <br />
                  <div>Upload RFI File(s)</div>
                  <br />
                  <Upload {...uploadProps} name="file" customRequest={this.uploadAttachment}>
                    <Button>
                      <Icon type="upload" /> Upload
                    </Button>
                  </Upload>
                </FilesUploadContainer>
              )}
              <Popconfirm
                title="Are you sure you want to delete this record?"
                onConfirm={this.confirmDelete}
                onCancel={this.cancelDelete}
                okText="Yes"
                cancelText="No"
              >
                {contentData && <Button type="danger" icon="delete" />}
              </Popconfirm>
            </Form>
          </Modal>
        )}
        <div className="jobsBar">
          RFI's
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD RFI
            </div>
          </div>
        </div>
        {this.props.jobSiteRFIActions.jobSiteRFIs && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTrProps={(state, rowInfo, column, instance) => ({
              onClick: e => this.handleRowClick(rowInfo.original)
            })}
            data={this.props.jobSiteRFIActions.jobSiteRFIs.data}
            columns={[
              {
                columns: [
                  {
                    Header: 'Number',
                    accessor: 'number',
                    maxWidth: 90,
                    className: 'textAlignCenter'
                  },
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                    )
                  },
                  {
                    Header: 'Status',
                    accessor: 'status',
                    maxWidth: 90
                  },
                  {
                    Header: 'Created By',
                    id: 'first_name',
                    accessor: d => {
                      const r = `${d.first_name} ${d.last_name}`
                      return <Tooltip title={r}>{r}</Tooltip>
                    },
                    maxWidth: 150
                  }
                ]
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({ jobSiteRFIActions, organizationsActions }, ownProps) => ({
  jobSiteRFIActions,
  organizationsActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, rfiActions, organizationsActions), dispatch)
})

JobSiteRFIs.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobSiteRFIs)))



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobSiteRFIs.js